export default {
  login: '/security/login',
  /* 查询所有类型 */
  productAll: '/product/queryAll',
  /* 获取所有省份 */
  // getProvinces: '/provinces/search/all',
  getProvinces: '/province/getAll',
  /* 获取已有省份 */
  getProvinceIds: '/send/getProvinceIds',
  /* 获取上传图片凭证 */
  uploadToken: 'secret/token',
  /* 专题 begin */
  // 列表
  querySpecialTopicInfo: 'specialTopicInfo/querySpecialTopicInfo',
  specialList: 'specialTopic/querySpecialTopic',
  // 详情
  specialDetail: 'specialTopic/queryById',
  queryOneSpecialTopicInfo: 'specialTopicInfo/queryOneSpecialTopicInfo',
  // 下架
  'xuanke/specialSoldOut': '/specialTopic/soldOut',
  'zhiyuan/specialSoldOut': 'specialTopicInfo/soldOutSpecialTopicInfo',
  // 删除
  'xuanke/specialDelete': '/specialTopic/delete',
  'zhiyuan/specialDelete': 'specialTopicInfo/deleteSpecialTopicInfo',
  // 新增修改
  specialHandle: '/specialTopic/saveAndUpdate',
  saveSpecialTopicInfo: 'specialTopicInfo/saveSpecialTopicInfo',
  /* 专题 end */
  /* 文章 begin */
  // 模块下的专题
  queryArticleInfoCondition: 'articleInfo/queryArticleInfoCondition',
  entranceClassQuery: 'entranceClass/queryEntranceClassCondition',
  // 列表
  articleList: '/article/queryArticleByCondition',
  queryArticleInfoByCondition: 'articleInfo/queryArticleInfoByCondition',
  // 升学课堂
  queryEntranceClassByCondition: 'entranceClass/queryEntranceClassByCondition',
  // 详情
  articleDetail: '/article/queryById',
  zhiyuan_articleDetail: 'articleInfo/queryById',
  zhiyuan_entranceClassDetail: 'entranceClass/queryById',
  // 删除
  'xuanke/articleDelete': '/article/delete',
  'zhiyuan/articleDelete': 'articleInfo/deleteArticleInfo',
  'EntranceClass/articleDelete': 'entranceClass/deleteEntranceClass',
  // 删除音视频
  'shengxue/deleteEntranceClassAudioVideo': 'entranceClass/deleteEntranceClassAudioVideo',
  // 下架
  'xuanke/articleSoldOut': '/article/soldOut',
  'zhiyuan/articleSoldOut': 'articleInfo/soldOutArticleInfo',
  'zhiyuan/articleEntranceClass': 'entranceClass/soldOutEntranceClass',
  // 新增修改
  articleHandle: 'article/addAndUpdate',
  zhiyuan_articleHandle: 'articleInfo/addAndUpdate',
  // 定时发布
  articlePublishDelay: 'article/publishDelay',
  zhiyuan_articlePublishDelay: 'articleInfo/publishDelay',
  // 直接发布
  articlePublishNow: 'article/publishNow',
  zhiyuan_articlePublishNow: 'articleInfo/publishNow',
  zhiyuan_entranceClassDirect: 'entranceClass/addEntranceClass',
  /* 文章 end */
  /* 话题 begin */
  // 列表
  topicList: '/gambit/queryByCondition',
  // 详情
  topicDetail: '/gambit/queryById',
  // 删除
  'xuanke/topicDelete': '/gambit/delete',
  // 下架
  'xuanke/topicSoldOut': '/gambit/soldOut',
  // 设为热门
  'xuanke/topicHot': '/gambit/setHot',
  // 新增修改
  topicHandle: '/gambit/addAndUpdate',
  // 定时发布
  gambitPublishDelay: 'gambit/publishDelay',
  // 直接发布
  gambitPublishNow: 'gambit/publishNow',
  // 评论列表
  queryCommentByThemeInfoId: 'comment/queryCommentByThemeInfoId',
  // 删除评论
  deleteCommentByCommentId: 'comment/deleteCommentByCommentId',
  /* 话题 end */
  /* 志愿卡开卡管理 begin */
  // 列表
  byCondition: '/membershipCardGenerateRecord/queryByCondition',
  // 生成志愿卡
  generate: '/membershipCard/generate',
  /* 根据会员卡id导出会员卡数据 的excel */
  exportByRecordId: '/membershipCard/exportByRecordId',
  /* 志愿卡开卡管理 end */
  /* 志愿卡使用管理 begin */
  getMembershipCards: '/membershipCard/byCondition',
  // 改价 批量改价
  alterMembershipCardRange: '/membershipCard/alterMembershipCardRange',
  // 卡片区段
  membershipCardRange: '/membershipCard/membershipCardRange',
  // 手动激活
  activationUser: '/activationUser/manualActivation',
  // 激活列表查询
  queryRecord: '/activationUser/queryRecord',
  /* 志愿卡使用管理 end */
  /* 个人中心 begin */
  // 反馈列表
  getFeedback: 'feedbacks/getFeedback',
  /* 个人中心 end */
  /* 交易管理 begin */
  // 订单
  getOrderList: '/order/getListByCondition',
  /* 交易管理 end */
  /* banner begin */
  // 列表
  bannerList: '/banner/queryByCondition',
  zhiyuan_bannerList: 'bannerInfo/queryBannerInfo',
  // 详情
  bannerDetail: '/banner/getOne',
  zhiyuan_bannerDetail: 'bannerInfo/queryOneBannerInfo',
  // 模块-专题-文章
  bannerQueryCondition: 'bannerInfo/queryCondition',
  // 删除
  'xuanke/bannerDelete': 'banner/deleteByIds',
  'zhiyuan/bannerDelete': 'bannerInfo/deleteBannerInfo',
  // 下架
  'xuanke/bannerSoldOut': '/banner/soldOut',
  'zhiyuan/bannerSoldOut': 'bannerInfo/soldOutBannerInfo',
  // 直接发布
  bannerPublishNow: '/banner/publishNow',
  zhiyuan_bannerPublishNow: 'bannerInfo/directBannerInfo',
  // 定时发布
  bannerPublishDelay: '/banner/publishDelay',
  zhiyuan_bannerPublishDelay: 'bannerInfo/timingBannerInfo',
  // 草稿
  bannerSave: '/banner/save',
  zhiyuan_bannerSave: 'bannerInfo/draftBannerInfo',
  /* banner end */
  /* 系统管理 begin */
  // 用户列表
  getUsers: '/user/getUsers',
  // 发送验证码
  sendSms: '/user/sendSms',
  // 用户账号是否存在
  nameIsExits: '/user/isExist/',
  existPassword: '/user/existPassword',
  // 重置密码
  resetPassword: '/user/resetPassword',
  // 详情
  userGetOne: '/user/getOne',
  // 删除
  'system/userDelete': '/user/delete',
  // 新增
  userSave: '/user/saveOrUpdate',
  // 角色列表
  getRoles: '/role/getRoles',
  // 新增
  roleSave: '/role/saveOrUpdate',
  // 删除
  roleDelete: '/role/delete/',
  // 详情
  roleGetOne: '/role/getOne',
  // 角色名是否已存在
  roleIsExist: 'role/existName',
  // 超级用户列表
  getSuperUsers: '/superUser/getSuperUsers',
  // 新增
  superUserSave: '/superUser/save',
  // 删除
  superUserDelete: '/superUser/delete',
  // app自动化升级
  appList: '/appVersion/getAppVersions',
  // 修改状态 已发布/下架
  appChangeStatus: '/appVersion/change',
  // 新增
  appSave: '/appVersion/save',
  // 版本号是否存在
  VersionIsExit: '/appVersion/isExist',
  /* 系统管理 end */
  /* 直接推送 */
  bannerSend: '/send/sendTo',
  /* 定时推送 */
  bannerSchedule: '/send/schedule',
  // 新增经销商
  addDealer: '/dealer/addDealer',
  // 查询业务员 卡激活统计数量
  getCardCountByUser_new: '/dealerCard/getCardCountByUser_new',
  // 统计报表查询销售记录
  queryCardSalesRecord: '/dealerCard/queryCardSalesRecord',
  //查询经销商列表
  queryDealers: '/dealer/queryDealers',
  //查询经销商详情
  getDealerDetail: '/dealer/getDealerDetail',
  //修改经销商信息
  editDealer: '/dealer/editDealer',
  //获取经销商组织树
  getDealerOrgTree: '/dealer/getDealerOrgTree',
  //获取所有省份
  schoolGetProvinces: '/school/getProvinces',
  //根据省份获取城市列表
  getCitys: '/school/getCitys',
  // 根据城市获取区县
  getDistrictsByCityId: '/school/getDistrictsByCityId',
  // 获取区县下面的学校
  getSchoolsByDistrictId: '/school/getSchoolsByDistrictId',
  //根据城市经销商编号获取学校列表
  getSchools: '/school/getSchools',
  //新增经销商组织信息
  addDealerOrg: '/dealer/addDealerOrg',
  //查询经销商组织信息
  getDealerOrg: '/dealer/getDealerOrg',
  //删除经销商组织学校信息 (修改经销商组织调用)
  delDealerOrgSchool: '/dealer/delDealerOrgSchool',
  //删除经销商组织信息
  delDealerOrg: '/dealer/delDealerOrg',
  //修改经销商组织信息
  editDealerOrg: '/dealer/editDealerOrg',
  //查询经销商组织下的学校列表信息
  getDealerOrgSchools: '/dealer/getDealerOrgSchools',
  //删除经销商
  delDealer: '/dealer/delDealer',
  //冻结或者解冻经销商
  freezingOrThawing: '/dealer/freezingOrThawing',
  //获取当前登陆用户组织树
  getMyOrgTreeCondition: '/org/getMyOrgTreeCondition',
  //获取当前登陆用户下级业务员集合（下拉筛选条件
  getUserCondition: '/org/getUserCondition',
  //根据用户集合过滤出经销商下拉列表
  getDealerCondition: '/dealer/getDealerCondition',
  // 绑卡经销商列表下拉
  getDealers: '/dealer/getDealers',
  //根据经销商编号 查询学校列表
  getSchoolsCondition: '/dealer/getSchoolsCondition',
  //获取所有组织树
  getOrgTree: '/org/getOrgTree',
  //添加组织
  addOrg: '/org/addOrg',
  //查询未加入组织的用户
  getUserByNoOrg: '/org/getUserByNoOrg',
  //添加用户到组织
  addUserToOrg: '/org/addUserToOrg',
  //根据组织编号查询 组织下的用户列表
  getUserByOrg: '/org/getUserByOrg',
  //修改组织
  editOrg: '/org/editOrg',
  //删除组织
  delOrg: '/org/delOrg',
  entranceClassSend: 'entranceClass/queryEntranceClassCondition',
  //我的卡
  queryCardsByDealer: '/dealerCard/queryCardsByDealer',
  //卡数量统计
  getUserCardCount: '/dealerCard/getUserCardCount',
  //经销商绑卡列表
  queryBindMembershipCardRecord: '/membershipCard/queryBindMembershipCardRecord',
  //经销商绑卡
  bindDealer: '/membershipCard/bindDealer',
  //卡片冻结、解冻
  updateCardStatus: '/membershipCard/updateCardStatus',
  //查询卡池剩余数量
  queryCardNumberByType: '/membershipCard/queryValidMembershipCardNumberByType',
  //卡激活统计数量
  getCardCountByUser: '/dealerCard/getCardCountByUser',
  //查询供应商销售记录
  queryDealerCardSalesRecord: '/membershipCard/queryDealerCardSalesRecord',
  //获取导出Token
  getExportToken: '/membershipCard/exportToken/generate',
  //导出绑卡数据
  exportBindRecordData: '/membershipCard/exportByBindRecordId/',
  // 人工激活
  manualActivation: '/membershipCard/manualActivation',
  //人工激活完善信息
  perfectUserData: '/membershipCard/perfectUserData',
  //查询经销商使用信息
  queryDealerCard: '/membershipCard/queryDealerCard',
  // 查询专业预约
  queryAppointment: '/specialistAppoint/showExpertsToMakeAnAppointment',
  // 加盟申请
  queryApply: '/leagueInfo/showJoinApply',
  // 检验经销商是否已绑定学校
  checkSchool: '/school/checkSchool',
  // 导出销售记录
  exportData: '/dealerCard/exportData',
  // 重置密码(去掉验证码)
  updatePassWord: '/user/updatePassWord',
  // 日志查询
  logs: '/logs',
  // 会员管理
  queryCommonUserInfoByCondition: '/commonUserInfo/queryCommonUserInfoByCondition',
  // 会员复位
  resetUserAuthority: '/commonUserInfo/resetUserAuthority',
  // 会员历史
  queryCommonUserInfoHistoryByPhoneNumber: '/commonUserInfo/queryCommonUserInfoHistoryByPhoneNumber',
  // 会员导出
  exportCommonUserInfo: '/commonUserInfo/exportCommonUserInfo',
  // 导出订单
  exportExcel: '/order/exportExcel',
  // 查询活动/新增活动
  wechatActivities: '/wechatActivities',
  // 获取活动支持的VIP类型
  wechatVipTypes: '/wechatActivities/vipTypes',
  // 生成一个唯一的活动的id
  wechatGenerateId: '/wechatActivities/generateId',
  // 到处活动数据到excel
  wechatExportExcel: '/wechatActivities/exportExcel',
  // 分页获取生涯主题活动
  syActivities: '/syActivities',
  // 获取所有可用的生涯主题活动模块
  syActivityModules: '/syActivityModules',
  // 导出二维码
  qrCode: '/syActivities/$id/students/qrCode',
  // 下载导入模板
  download: '/syActivityStudents/import/template/download',
  // 通过excel导入学生数据
  importData: '/syActivities/$id/students/import',
  //获取一个学生的所有活动参与记录
  playRecords: '/syStudents/$id/playRecords',
  //新增或修改企业信息Api
  EnterpriseInfo: '/enterprise/addOrUpdateEnterpriseInfo',
  // 条件查询机构客户列表Api
  obtainEnterprise: '/enterprise/obtainEnterprise',
  // 查找所有省份
  findAll: '/enterprise/findAll',
  // 根据id查询企业信息Api
  getOne: '/enterprise/getOne',
  // 新增1对1 新闻
  addOrUpdateForOfficialWeb: '/articleInfo/addOrUpdateForOfficialWeb',
  // 小程序专题列表
  obtainAppletSpecialTopic: '/appletSpecialTopic/obtainAppletSpecialTopic',
  // 新增或修改小程序专题
  appletAddOrUpdate: '/appletSpecialTopic/addOrUpdate',
  // 设置小程序专题状态
  setSpecialTopicStatus: '/appletSpecialTopic/setSpecialTopicStatus',
  // 删除小程序专题
  deleteAppletSpecialTopic: '/appletSpecialTopic/delete',
  // 主键查询专题
  appletFindById: '/appletSpecialTopic/findById',
  // 小程序文章列表
  obtainAppletArticle: '/appletArticle/obtainAppletArticle',
  // 设置小程序文章状态
  setArticleStatus: '/appletArticle/setArticleStatus',
  // 删除小程序文章
  deleteAppletArticle: '/appletArticle/delete',
  // 小程序订单列表
  mpGoodsOrders: '/goodsOrders',
  // 上传视频的签名
  obtainUploadSignature: '/appletArticle/obtainUploadSignature',
  // 新增或修改小程序文章
  articleAddOrUpdate: '/appletArticle/addOrUpdate',
  // 获取专题列表
  obtainSpecialTopicIdAndTitle: '/appletSpecialTopic/obtainSpecialTopicIdAndTitle',
  // 导出小程序订单
  mpOrdersExport: '/goodsOrders/exportExcel',
  // 根据id查询文章
  appletArticleFindById: '/appletArticle/findById',
  // 根据id删除文章视频
  deleteVideoById: '/appletArticle/deleteVideoById',
  // 获取咨询列表
  getZixun: '/consultation/obtainDataByCondition',
  //获取咨询回复状态
  // getZinxunStatus: '/consultation/obtainReplyStatus',
  //  通过id获取咨询详情
  getZixunDetail: '/consultation/obtainDataById',
  //回复咨询
  replyZixun: '/consultation/reply',
  //获取机构充值列表
  getRechargeList: '/walletOms/obtainListByConditionOnOms',
  //模糊查询充值企业列表Api
  getQyList: '/walletOms/obtainTopUpEnterprise',
  //向企业账户充值Api
  wallet: ' /walletOms/topUp',
  // 知涯小程序专题获取
  // obtainApplet: '/applet/obtainAppletSpecialTopic',
  // 获取知涯小程序课程内容
  // obtainAppletContent: '/applet/obtainAppletContent'
  // 获取生涯课堂
  obtainAppletContent: '/bannerInfo/obtainAppletContent',
  // 获取心理健康
  obtainAppletContentByLabel: '/bannerInfo/obtainAppletContentByLabel',
  // 获取研学活动
  getStudentManagement: '/bannerInfo/getStudentManagement'

}



// WEBPACK FOOTER //
// ./src/utils/api.js